"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var redux_1 = require("redux");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
var business_1 = __importDefault(require("./business"));
var reducer_1 = __importDefault(require("./globalConstants/reducer"));
var store_1 = __importDefault(require("../../app/containers/AissNode/store"));
var store_2 = __importDefault(require("../../app/containers/AIAgents/store"));
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
var store = redux_1.createStore(redux_1.combineReducers({
    business: business_1["default"],
    globalConstants: reducer_1["default"],
    aiss: store_1["default"],
    aiAgent: store_2["default"],
}), composeEnhancers(redux_1.applyMiddleware(redux_thunk_1["default"])));
exports["default"] = store;
